<template>
  <div class="followup-portrait-fields" data-followup-portrait>
    <div class="mt10 c-8F8E8E">本次3.0及以上画像：{{portraitText}}</div>
    <div class="mt10 c-8F8E8E">本次服务周期：{{cycleText}}</div>
  </div>
</template>
<script>
import { portraitConclusionText, serviceCycleText } from '@/utils/customerPortrait'
export default {
  props: { record: { type: Object, required: true } },
  computed: {
    portraitText() { return this.record.isPortrait30 === null || this.record.isPortrait30 === undefined ? '未选择' : portraitConclusionText(this.record.isPortrait30) },
    cycleText() { return this.record.serviceCycle == null ? '未选择' : serviceCycleText(this.record.serviceCycle) }
  }
}
</script>
